/** Shared rules for email/phone entry popups (register, login, register modal). */

export function emailDomainOk(value: string): boolean {
  const parts = value.split("@");
  if (parts.length < 2 || !parts[1]) return false;
  const domain = parts[1];
  if ((domain.match(/\.com/g) || []).length > 1) return false;
  const tld = domain.split(".");
  const last = tld.pop();
  return !!(last && /^[a-zA-Z]{2,}$/.test(last));
}

export function isValidEmailFormat(value: string): boolean {
  if (value.length > 254) return false;
  const at = value.indexOf("@");
  if (at <= 0 || at !== value.lastIndexOf("@")) return false;
  const local = value.slice(0, at);
  const domain = value.slice(at + 1);
  if (!local || !domain?.includes(".")) return false;
  const tld = domain.slice(domain.lastIndexOf(".") + 1);
  return tld.length >= 2 && !/\s/.test(value);
}

export function isValidContactEmail(value: string): boolean {
  const v = String(value).trim();
  return isValidEmailFormat(v) && emailDomainOk(v);
}

export function isValidContactPhoneDigits(digits: string): boolean {
  return /^[6-9]\d{9}$/.test(digits);
}

export type SeedRegistrationOtpState = {
  email: string;
  phoneNumber: string;
  name?: string;
  method: "email" | "mobile";
};

/** Per-field messages for ContactEntryDialogs (name / email / phone). */
export type ContactEntryFieldErrors = Partial<Record<"name" | "email" | "phone", string>>;
